import React from 'react'
import {
  textWithHTML,
  percentage,
  numberMoney,
  textToNumber,
} from 'Data/format.js'
import { useDataValue } from 'Simple/Data.js'

import View from './view.js'

export default function Logic(props) {
  let card_fee_percent = useDataValue({
    context: 'payment',
    path: 'card_fee_percent',
    viewPath: props.viewPath,
  })

  let amount = textToNumber(props.amount)

  return (
    <View
      text={textWithHTML(
        `A <b>platform fee of ${
          amount
            ? `${numberMoney((amount * card_fee_percent) / 100)} (${percentage(card_fee_percent)})`
            : percentage(card_fee_percent)
        }</b> will be applied to this card payment. <b>Pease note:</b> This fee may not be considered an eligible expense under a tax-advantaged account. Our system is designed to exclude this fee for Health Savings Account (HSA), Flexible Spending Account (FSA), Health Reimbursement Arrangement (HRA),and insurance reimbursement cards. However, some may not be excluded due to inconsistencies in how issuing banks categorize certain cards.`
      )}
      {...props}
    />
  )
}
